import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import {
   BrowserRouter,
   Routes,
   Route,
   useNavigate,
   Navigate,
   useLocation,
} from "react-router-dom";
import Login from "./pages/Login";
import NoMatch from "./pages/NoMatch";
import Flowchart from "./components/Flowchart";
import "./css/colors.css";
import NavbarWrapper from "./components/Navbar";
import Home from "./pages/Home";
import Report from "./pages/Report";
import Temp from "./pages/Temp";
import Diagnose from "./pages/Diagnose";
import Cookies from "universal-cookie";
import SummaryPDFViewer from "./pages/SummaryPDFViewer";

const cookies = new Cookies();

const root = ReactDOM.createRoot(
   document.getElementById("root") as HTMLElement
);

const RequireAuth = ({
   screen,
   children,
}: {
   screen: string;
   children: JSX.Element;
}) => {
   let location = useLocation();

   if (!cookies.get("token")) {
      // Redirect them to the /login page, but save the current location they were
      // trying to go to when they were redirected. This allows us to send them
      // along to that page after they login, which is a nicer user experience
      // than dropping them off on the home page.
      return <Navigate to="/" state={{ from: location }} replace />;
   }

   return <NavbarWrapper screen={screen}>{children}</NavbarWrapper>;
};

root.render(
   <BrowserRouter>
      <Routes>
         <Route path="/" element={<Login />} />
         <Route path="/temp" element={<Temp />} />
         <Route path="/summaryPDF" element={<SummaryPDFViewer />} />
         <Route
            path="/home"
            element={
               <RequireAuth screen="home">
                  <Home />
               </RequireAuth>
            }
         />
         <Route
            path="/diagnose"
            element={
               <RequireAuth screen="diagnose">
                  <Diagnose />
               </RequireAuth>
            }
         />
         <Route
            path="/report"
            element={
               <RequireAuth screen="report">
                  <Report />
               </RequireAuth>
            }
         />
         <Route path="/*" element={<NoMatch />} />
      </Routes>
   </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
